<!-- 柱状图 -->
<style lang="stylus" scoped>
.bar-wrap {
  height: 32.5vh;
  display: flex;
  flex-wrap: wrap;
  padding-left: 4vh;
  padding-top: 1vh;
}

.temp {
  width: 31.5%;
  height: 14.2vh;
  margin-right: 1%;
  margin-bottom: 1%;

  img {
    width:100%;
    height: 14.2vh;
  }

  span {
    width: 100%;
    height: 3vh;
    font-size: 1.8vh;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    text-align: center;
    display: inline-block;
    position: relative;
    left:0;
    right:0;
    top: -3vh;
    line-height: 2.8vh;
  }
}
</style>

<template>
  <boxWrap :name="name" :min="true">
    <div class="bar-wrap">
      <div v-for="(item, index) in tableData" class="temp" v-if="tableData.length > 0 && index < 6">
        <img :key="item.productUrl" :src="`${url}${item.productUrl.split(',')[0]}`" />
        <span :key="item.productName">{{ item.productName }}</span>
      </div>
    </div>
  </boxWrap>
</template>

<script>
import echarts from 'echarts'
import boxWrap from '../common/boxWrap';
import config from '../../../../../../static/config/config';

export default {
  props: ['productRelationStatisticsList'],
  data() {
    return {
      name: '可追溯商品',
      tableData: [],
      url: config.fileDomain
    }
  },
  components: {
    boxWrap
  },
  methods: {
  },
  mounted() {
    this.tableData = this.productRelationStatisticsList
  }
}

</script>



// WEBPACK FOOTER //
// index.vue?b1884174